// ModifierPills — renders any modifier list as the gold effect pills used
// across facility/upgrade cards. One generic component instead of a
// hardcoded per-effect-type switch in each tab.

import { formatModifier, type Modifier } from '@/game/systems/ModifierSystem'

export function ModifierPills({ mods, style }: { mods: Modifier[]; style?: React.CSSProperties }) {
  if (mods.length === 0) return null
  return (
    <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap', ...style }}>
      {mods.map((mod, i) => (
        <span key={i} className="pill" style={{ background: 'var(--gold-fill)', color: 'var(--gold)' }}>
          {formatModifier(mod)}
        </span>
      ))}
    </div>
  )
}
